import "../css/card_design.css";
import "../css/Nav design.css";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import LookUpRequest from "../model/request/LookupRequest";
import UpdateDetailsResponse from "../model/response/UpdateDetailsResponse";
import UpdateDetails from "../model/request/UpdateDetails";
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { Oval } from "react-loader-spinner";


function Groom() {
    var location = useLocation();
    var { profile } = location.state || {};

    const [activeuser, setActiveUser] = useState([]);

    var [address1, setAddress1] = useState(profile.line_1);
    var [address2, setAddress2] = useState(profile.line_2);

    var [Country, setCountry] = useState(profile.countryId);
    var [stateList, setStateList] = useState([]);
    var [State, setState] = useState(profile.stateCode);
    var [StateItem, setStateItem] = useState("");
    var [stateId, setStateId] = useState(profile.state_Id);
    var [districtList, setDistrictList] = useState([]);
    var [District, setDistrict] = useState(profile.district_Id);
    var [DistrictId, setDistrictId] = useState("");
    const [Ancestral, setAncestral] = useState(profile.ancestral_Origin);
    const [citizenship, setCityzenship] = useState(profile.citizenship);


    const [isLoading, setIsLoading] = useState(false)

    const navigation = useNavigate()

    function clicktoEditprofile() {
        navigation('/Editprofile')
        setIsLoading(true);
    }


    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;


    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    console.log(profile.countryId + " - district_Id");


    function GroomLocationAPICall() {
        setIsLoading(true);
        var request = new UpdateDetails();

        request.user_Id = loginVal.user_Id;
        request.state_Id = parseInt(stateId);
        request.district_Id = parseInt(District);
        request.country_Id = parseInt(Country);
        request.citizenship = citizenship;
        request.line_1 = address1;
        request.line_2 = address2;
        // request.city = parseInt(District);
        request.ancestral_Origin = Ancestral;
        console.log("stateId " + request.state_Id);

        console.log("Response:", JSON.stringify(request));
        axios.put(
            ApiConfig.getUrl("User/updateLocation"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                //  console.log("statusCode:", login.user_Id);

                const profileVal = UpdateDetailsResponse.fromJson(api.response);

                console.log("Response:", JSON.stringify(profileVal));
                setActiveUser(profileVal);

                showToast("Update successfull");

                setIsLoading(false);
            })

            .catch(error => {
                console.error("Error:", error);
                showToastFailed("Update Error");
                setIsLoading(false);
            });
    }

    console.log(profile.stateCode);

    useEffect(() => {
        stateAPICall();

    }, [])
    console.log(State);

    console.log(profile.stateCode);

    function stateAPICall() {
        var request = new LookUpRequest();
        request.countrycode = "IN";
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/state"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {
                // setStateList(response.dataList)
                console.log("Responsesadsadsad:", response.data.response);
                const dataList = response.data.response.dataList;
                console.log("Responsesa:", dataList);
                setStateList(dataList)

                //  setStateId(profile.state_Id)
                districtAPICall(State);
                // navigation('/Verify', { state: { userRegister: userObject } })

            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    console.log(profile.state_code);

    function districtAPICall(code) {
        var request = new LookUpRequest();
        request.state_code = code;
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/district"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {
                console.log("Responsesadsadsad:", response.data.response);
                const dataList = response.data.response.dataList;
                console.log("Responsesa:", dataList);

                setDistrictList(dataList)

            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

     const disableRightClick = (e) => {
    e.preventDefault();
  };


    return (
        <>
            <div  onContextMenu={disableRightClick}>
                <ToastContainer />


                <div className="fullview" style={{ fontFamily: " font-family: Arial, Helvetica, sans-serif" }}>
                    {isLoading && (
                        <div className="loader-overlay">
                            <Oval
                                height={60}
                                width={60}
                                color="#ffffff"
                                secondaryColor="#cccccc"
                                strokeWidth={4}
                                visible={true}
                            />
                        </div>
                    )}
                    < div className="container border p-5">
                        <div className='topic-row'>
                            <h2>Groom's/Bride's Locations</h2>
                            <button className="Edit-btn" onClick={clicktoEditprofile}>Close</button></div>
                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Country" id="Country" >Country Living in :</label></div>
                            <select id="Country" className="input_box" value={Country} onChange={(e) => setCountry(e.target.value)}>
                               
                                <option value="103">India</option>
                            </select>
                            {/* <div><input type="text" className="input_box" value={Country ?? ""} onChange={(e) => setCountry(e.target.value)} />
                </div> */}
                        </div>
                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Citizenship" id="Citizenship" >Citizenship :</label></div>

                            <input type="text" className="input_box" value={citizenship} onChange={(e) => setCityzenship(e.target.value)} />
                        </div>
                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Residing State" id="Residing State" >Residing State :</label></div>
                            <div><select id="State" className="input_box" value={State}
                                onChange={(e) => {
                                    // console.log("Responsesadsadsad:", e.target.key);
                                    // const obj = JSON.parse(e.target.value);

                                    const selectedState = stateList.find(s => s.code === e.target.value);
                                    setStateItem(selectedState);
                                    setState(e.target.value);
                                    setStateId(selectedState.id);
                                    console.log("disctrict IDd:", selectedState.id);
                                    districtAPICall(e.target.value);

                                    // }
                                }}>
                                <option value="">--State--</option>
                                {stateList.map((item) => (
                                    <option key={item.id} value={item.code}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            </div>
                        </div>
                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Residing State" id="Residing State" >Residing City / District :</label></div>
                            <div><select id="District" className="input_box" value={District}
                                onChange={(e) => {
                                    setDistrict(e.target.value)
                                    console.log("Responsesadsadsad:", e.target.value);

                                }}>
                                <option value="">--District--</option>
                                {districtList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            </div>
                        </div>
                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Ancestral Origin" id="Ancestral Origin" >Address :</label></div>
                            <div>
                                <input type="text-area"
                                    value={address1}
                                    onChange={(e) => setAddress1(e.target.value)}
                                    className="input_box"
                                    placeholder="D.No / Street / area" />


                                <div>
                                    <input type="text-area"
                                        value={address2}
                                        onChange={(e) => setAddress2(e.target.value)}

                                        className="input_box" placeholder="Village / Town" />
                                </div>
                            </div>
                        </div>


                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Ancestral Origin" id="Ancestral Origin" >Ancestral Origin :</label></div>
                            <div><input type="text" className="input_box" value={Ancestral} onChange={(e) => setAncestral(e.target.value)} /></div></div>

                        <div className="btn-group mt-3">
                            <button style={{ backgroundColor: "var(--primary-color)" }} onClick={GroomLocationAPICall} className="btn">Save</button>
                            <button style={{ backgroundColor: "lightgrey" }} className="btn" onClick={clicktoEditprofile}> Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='bg-dark text-white text-center '>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>



    );
}
export default Groom;